<template>
  <div v-if="visible" class="modal-overlay">
    <div class="modal-container">
      <div class="main-message">
        <div class="main-message-box">
          <img
            class="main-message-icon"
            src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-10Popde1.png"
            alt=""
          />
          {{ tit }}
        </div>
        <img
          @click="close"
          class="close"
          src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-10Popde2.png"
          alt=""
        />
      </div>
      <div class="secondary-message">{{ text }}</div>
      <div class="modal-footer">
        <button class="confirm-btn" @click="close">我知道了</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CameraBlockedModal",
  props: {
    // visible: {
    //   type: Boolean,
    //   default: true
    // }
  },
  data() {
    return {
      text: "",
      tit: "",
      originalBodyOverflow: "", // 保存原始 overflow 值
      visible: false,
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        // 弹窗显示：禁止背景滚动
        this.disableBodyScroll();
      } else {
        // 弹窗隐藏：恢复背景滚动
        this.enableBodyScroll();
      }
    },
  },
  mounted() {
    // 如果组件创建时 visible 默认为 true，也需要禁止滚动（但一般初始为 false）
    if (this.visible) {
      this.disableBodyScroll();
    }
  },
  beforeDestroy() {
    // 组件销毁前确保恢复滚动（防止组件被强行移除时滚动仍被禁用）
    this.enableBodyScroll();
  },
  methods: {
    open(tit, text) {
      this.tit = tit;
      this.text = text;
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    disableBodyScroll() {
      // 保存当前 body 的 overflow 样式（可能为空或已有值）
      this.originalBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    },
    enableBodyScroll() {
      // 恢复原来的 overflow 样式
      document.body.style.overflow = this.originalBodyOverflow;
      // 清除保存的值（可选）
      this.originalBodyOverflow = "";
    },
  },
};
</script>

<style lang="scss" scoped>
/* 遮罩层：固定全屏，半透明背景 */

@media all and (min-width: 768px) {
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    animation: fadeIn 0.2s ease;
  }

  /* 弹窗容器：圆角卡片，白色背景 */
  .modal-container {
    width: 42.375rem; /* 360px → 22.5rem */
    height: 17.625rem;
    background-color: #ffffff;
    border-radius: 1.25rem; /* 20px → 1.25rem */
    box-shadow: 0 1.25rem 2.5rem rgba(0, 0, 0, 0.15); /* 20px→1.25rem, 40px→2.5rem */
    padding: 1.75rem 0rem 1.5rem; /* 28px→1.75rem, 24px→1.5rem */
    box-sizing: border-box;
    animation: scaleIn 0.2s ease;
  }

  /* 主标题 */
  .main-message {
    font-weight: bold;
    font-size: 1.5rem;
    color: #101424;
    text-align: left;
    font-style: normal;
    text-transform: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 2.375rem;
    padding: 0rem 2.2rem;
    .main-message-box {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      .main-message-icon {
        width: 1.875rem;
        height: 1.875rem;
        margin-right: 0.3rem;
      }
    }
    .close {
      width: 1.875rem;
      height: 1.875rem;
      cursor: pointer;
    }
  }

  /* 辅助文字 */
  .secondary-message {
    height: 5.25rem;
    line-height: 5.25rem;
    box-sizing: border-box;
    padding-left: 2.75rem;
    font-weight: 400;
    font-size: 1.25rem;
    color: #797b84;
    text-align: left;
    font-style: normal;
    text-transform: none;
    border-top: 0.0625rem solid #f5f6fe;
    border-bottom: 0.0625rem solid #f5f6fe;
    margin-top: 1.25rem;
    margin-bottom: 1.6rem;
  }

  /* 底部按钮容器 */
  .modal-footer {
    display: flex;
    justify-content: flex-end;
  }

  /* “我知道了”按钮 */
  .confirm-btn {
    width: 9.3125rem;
    height: 3.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #0074fc;
    border-radius: 0.75rem;
    font-weight: 400;
    font-size: 1.5rem;
    color: #ffffff;
    text-align: center;
    font-style: normal;
    text-transform: none;

    border: none;
    cursor: pointer;
    transition: background-color 0.15s;
    box-shadow: 0 0.25rem 0.5rem rgba(37, 99, 235, 0.2); /* 4px→0.25rem, 8px→0.5rem */
    outline: none;
    display: inline-flex;
    align-items: center;
    border: 0.0625rem solid transparent; /* 1px → 0.0625rem */
    margin-right: 2.875rem;
  }
}

@media (max-width: 767px) {
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    animation: fadeIn 0.2s ease;
  }

  /* 弹窗容器：圆角卡片，白色背景 */
  .modal-container {
    width: 42.375rem; /* 360px → 22.5rem */
    // height: 17.625rem;
    height: auto;
    background-color: #ffffff;
    border-radius: 2rem; 
    box-shadow: 0 1.25rem 2.5rem rgba(0, 0, 0, 0.15); /* 20px→1.25rem, 40px→2.5rem */
    padding: 2rem 0rem 2rem; 
    box-sizing: border-box;
    animation: scaleIn 0.2s ease;
  }

  /* 主标题 */
  .main-message {
    font-weight: bold;
    font-size: 2.2rem;
    color: #101424;
    text-align: left;
    font-style: normal;
    text-transform: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 2.5rem;
    padding: 0rem 2.2rem;
    .main-message-box {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      .main-message-icon {
        width: 2.7rem;
        height: 2.7rem;
        margin-top: 0.3rem;
        margin-right: 0.7rem;
      }
    }
    .close {
      width: 2.5rem;
      height:2.5rem;
      cursor: pointer;
    }
  }

  /* 辅助文字 */
  .secondary-message {
    height: auto;
    line-height: 3rem;
    box-sizing: border-box;
    padding: 1.2rem 2.75rem;
    font-weight: 400;
    font-size: 1.8rem;
    color: #797b84;
    text-align: left;
    font-style: normal;
    text-transform: none;
    border-top: 0.2rem solid #f5f6fe;
    border-bottom: 0.2rem solid #f5f6fe;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  /* 底部按钮容器 */
  .modal-footer {
    display: flex;
    justify-content: flex-end;
  }

  /* “我知道了”按钮 */
  .confirm-btn {
    // width: 9.3125rem;
    // height: 3.25rem;
    padding: 1rem 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #0074fc;
    border-radius: 0.75rem;
    font-weight: 400;
    font-size: 1.5rem;
    color: #ffffff;
    text-align: center;
    font-style: normal;
    text-transform: none;

    border: none;
    cursor: pointer;
    transition: background-color 0.15s;
    box-shadow: 0 0.25rem 0.5rem rgba(37, 99, 235, 0.2); /* 4px→0.25rem, 8px→0.5rem */
    outline: none;
    display: inline-flex;
    align-items: center;
    border: 0.2rem solid transparent;
    margin-right: 2.875rem;
  }
}
/* 淡入动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes scaleIn {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>